import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../hooks/useStore';
import { DataViewEditBox, useForm } from '../../../../lib/components';
import { GeneralDataForm } from './form';
import { GeneralDataView } from './view';

export const CompanyCoreData = observer(() => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const renderView = observer(() => <GeneralDataView data={companyStore.generalData} />);

  const renderEdit = () => {
    return (
      <GeneralDataForm
        initialValues={{
          address: {
            street_name: companyStore.generalData?.address?.street_name ?? '',
            street_number: companyStore.generalData?.address?.street_number || '',
            address_supplement: companyStore.generalData?.address?.address_supplement || '',
            zip_code: companyStore.generalData?.address?.zip_code || '',
            city: companyStore.generalData?.address?.city || '',
            province: companyStore.generalData?.address?.province || '',
            country: companyStore.generalData?.address?.country || ''
          },
          homepage_url: companyStore.generalData?.homepage_url || ''
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            await companyStore.updateGeneralData(values);
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };
  return (
    <DataViewEditBox
      title={t('company:CORE_DATA')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
